import React from 'react';
import { Provider } from 'react-redux';

import createHistory from '@guestyci/history/createHistory';

import { getUser, loginAsOwner, validateHash } from 'user/user.actions';
import { getOwnersPortalMeta, uiAction } from 'ui/ui.actions';
import { getHostName } from 'utils/common';
import configureStore from 'store';
import { getMatchingRoute } from 'routes/routes';
import { LoginPageModes } from 'constants/loginPageModes';

import App from './App';

const history = createHistory();
const store = configureStore();

const initApp = (initState, hash) => {
  if (
    [LoginPageModes.LOGIN, LoginPageModes.FORGOT_PASSWORD].includes(initState)
  ) {
    if (hash) {
      return store.dispatch(loginAsOwner(hash));
    }

    return Promise.resolve({
      email: '',
      name: '',
    });
  }

  if (hash) {
    return store.dispatch(validateHash(hash));
  }

  history.replace('/');
  return Promise.reject(Error('Invalid hash'));
};

class Root extends React.Component {
  constructor(props) {
    super(props);

    const { pathname, search } = window.location;
    const route = getMatchingRoute(pathname);
    // Extract hash from URL
    const hash = /[?&]hash=([^?&]*)/g.exec(search)?.[1] || '';

    const initState = [
      LoginPageModes.REGISTER,
      LoginPageModes.NEW_PASSWORD,
      LoginPageModes.FORGOT_PASSWORD,
    ].includes(route?.initState)
      ? route.initState
      : LoginPageModes.LOGIN;

    // TODO: check .then() and .catch(), it works just in this order
    store.dispatch(getOwnersPortalMeta(getHostName())).then(() =>
      initApp(initState, hash)
        .then((data) =>
          store.dispatch(
            uiAction({
              initState,
              hash,
              ...data,
            })
          )
        )
        .then(() => store.dispatch(getUser()))
        .catch((err) => {
          console.log(
            'Error during the app initialization: ',
            JSON.stringify(err)
          );
        })
    );
  }

  render() {
    return (
      <Provider store={store}>
        <App history={history} />
      </Provider>
    );
  }
}

export default Root;
